<template>
  <div class="project-management">
    <s-r-m-header ref="header" activeVal='projectManagement' />
    <carousel-container ref="carouselContainer" :carouselInfo="carouselInfo" />
    <ProjectDesc
      :descInfo="{
        title: '璞华PMS项目管理系统',
        description: '璞华PMS使制造业产品研发项目过程更透明，协同更高效、决策更准确',
        redContent: '璞华PMS（Project Management System）',
        content: '覆盖不同项目类型全生命周期管理，通过对业务流程及业务对象建模，精准管理项目过程中的任务、问题、风险，实现项目全生命周期的数字化管理，为高层精准决策、中层监控全面、基层高效执行、及经验及时沉淀与分享提供保障。'
      }"
    ></ProjectDesc>
    <Scheme :schemeList="schemeList"></Scheme>
    <CoreStrengths></CoreStrengths>
    <PointOfPain 
      ref="characteristic"
      :listData="listData" 
      title="多层级多角色协同应用"
      description="植根于用户需求，不断快速迭代升级"
    />
    <!-- <success-cases
      style="background: #FFFFFF;"
      ref="successCases"
      title="璞华PMS的典型案例"
      description="多行业领域的实施经验提供更加垂直化的解决方案，助力企业提升研发效率"
      :caseList="caseList"
    />
    <success-cases
      ref="successCases2"
      title="璞华易研PLM的典型案例"
      description="多行业领域的实施经验提供更加垂直化的解决方案，助力企业提升研发效率"
      :caseList="caseList2"
    /> -->
    <!-- <ChooseUs :nameVals="['electron']"></ChooseUs> -->
    <custom-form ref="customForm" />
    <footer-box />
  </div>
</template>

<script>
import SRMHeader from "@/components/SRMHeader/index";
import CarouselContainer from "@/components/CarouselContainer/single"
import PointOfPain from "@/components/PointOfPain/index"
import SuccessCases from "@/components/SuccessCases"
import Scheme from "@/components/Scheme"
import CustomForm from "@/components/Form"
import ChooseUs from "@/components/ChooseUs"
import FooterBox from "@/components/FooterBox"
import ProjectDesc from "@/components/ProjectDesc"
import CoreStrengths from "@/components/CoreStrengths"
import { baiduConsult } from "./common.js";


import hgs2 from '@/assets/images/hgs2.png'

import gn1 from '@/assets/images/gn1-1.png'
import gn2 from '@/assets/images/gn1-2.png'
import gn3 from '@/assets/images/gn1-3.png'
import gn4 from '@/assets/images/gn1-4.png'
import gn5 from '@/assets/images/gn1-5.png'

import al1 from '@/assets/images/al1-1.png'
import al2 from '@/assets/images/al1-2.png'
import al3 from '@/assets/images/al1-3.png'

import al2_1 from '@/assets/images/al2-1.png'
import al2_2 from '@/assets/images/al2-2.png'
import al2_3 from '@/assets/images/al2-3.png'


import xmjl1 from '@/assets/images/xmjl1.png'
import xmjl2 from '@/assets/images/xmjl2.png'
import xmjl3 from '@/assets/images/xmjl3.png'
import xmjl4 from '@/assets/images/xmjl4.png'

import zywt1 from '@/assets/images/zywt1.png'
import zywt2 from '@/assets/images/zywt2.png'
import zywt3 from '@/assets/images/zywt3.png'
import zywt4 from '@/assets/images/zywt4.png'
import zywt5 from '@/assets/images/zywt5.png'
import zywt6 from '@/assets/images/zywt6.png'

export default {
  components: {
    SRMHeader,
    CarouselContainer,
    ProjectDesc,
    PointOfPain,
    CustomForm,
    FooterBox,
    Scheme,
    SuccessCases,
    CoreStrengths,
    ChooseUs
  },
  metaInfo() {
    return {
      title: '璞华易研 - 企业级PLM&PMS解决方案',
      meta: [
        {
          name: 'keywords',
          content: '璞华易研,PLM,PMS,PDM,产品生命周期管理,研发项目管理,国产PLM,智能制造'
        },
        {
          name: 'description',
          content: '璞华官方热线：4006-160-730。璞华易研PLM&PMS，帮助客户高效实现产品生命周期管理和研发项目管理，在流程行业、医疗器械、芯片半导体、电子高科技、机械制造等方面拥有丰富的案例。'
        }
      ]
    }
  },
  data() {
    return {
      ratio: null,
      carouselInfo: {
        title: '璞华PMS（Project Management System）',
        description: '璞华PMS让项目管理实现数字化管理，更简单、更高效',
        bg: hgs2
      },
      tabList: [
        {
          name: 'first',
          label: '技术核心管理',
          title: '1. 技术核心管理',
          description: '围绕需求与实验，精细化管理资源池，实现高效的后勤保障、资源调度与资源复用',
          effectDrawing: gn1,
          contentList: [
            {
              title1: '配方管理',
              content1: 'BOM结构化、正反结构查询、替代料管理、自动计算、研发/生产多场景视图、版本比较'
            },
            {
              title1: '工艺管理',
              content1: '文件模板化、参数指标结构化、图文表并茂式呈现、单/多工序场景差异化维护、装备设备管理'
            },
            {
              
              title1: '实验过程管理',
              content1: '配方工艺多途径维护、样品物性数据可视化对比、自动出具实验与检验报告、权限多维度细分'
            },
            {
              title1: '材料成本分析',
              content1: '配方材料成本自动计算、物料价格走势图表化比对'
            },
            {
              title1: '配方成本预测',
              content1: '物料价格影响利润预测、配方成本虚拟运算、浮动情况可视化比较'
            }
          ]
        },
        {
          name: 'second',
          label: '资源池管理',
          title: '2. 资源池管理',
          description: '以配方、工艺、成本为核心，整合产品全生命周期数据，涓汇、沉淀经验库',
          effectDrawing: gn2,
          contentList: [
            {
              title1: '配方高级检索',
              content1: 'B支持以物性要求、原料占比等多条件维度检索产品配方资源池，获取适配的历史经验参考'
            },
            {
              title1: '实验设备看板',
              content1: '支持设备资产管理，动态维护实验设备状态，预约协调档期，利用率、故障率可视化统计'
            },
            {
              title1: '实验人员看板',
              content1: '支持看板动态维护实验人员状态，预约、协调其档期，支持工时统计、比较'
            },
            {
              title1: '实验物料库存',
              content1: '支持实验物料出入库管理，自动扣减实验打样所耗物料，提供呆滞料数量、价值可视化统计'
            },
            {
              title1: '模具耗材管理',
              content1: '提供实验模具、耗材等出入库管理台账，自动分配编号批号，助力资源库存预警，及时补货备货'
            }
          ]
        },
        {
          name: 'third',
          label: '效率工具',
          title: '3. 效率工具',
          description: '基于提质增效目标，配套灵活的个性化效率工具，助力研发活动响应效率',
          effectDrawing: gn3,
          contentList: [
            {
              title1: '系统模板',
              content1: '内置多套材料化工行业文件模板方案，支持用户个性化自定义、扩展'
            },
            {
              title1: '代办授权',
              content1: '支持业务流程临时委托代办授权，支持各对象读写用临时授权，配套快速审核等在线监督机制'
            },
            {
              title1: '流程效率分析',
              content1: '提供业务流程效率分析，支持以流程类型、流转节点、操作者等多维度分析业务流转效率'
            },
            {
              title1: '在线可视化',
              content1: '采用最新的BS架构，支持40多种主流的文件格式在线预览，所见即所得；配套多场景自动图表'
            },
            {
              title1: '第三方集成',
              content1: '自带主流的集成接口，轻松实现与ERP、MES、办公软件等的集成协同，支持数据导出'
            }
          ]
        },
        {
          name: 'four',
          label: '五大基石',
          title: '4. 五大基石',
          description: '内置材料化工通用的业务对象管理，为产品履历、数据分析、知识传承奠定坚实的基础',
          effectDrawing: gn4,
          contentList: [
            {
              title1: '物料',
              content1: '编码规则自定义、型号/牌号关联、属性配置、生命周期管理、版本管理、分类分组定义、自动转码等'
            },
            {
              title1: '文档',
              content1: '内置行业常用文档模型（如标准法规、检验规范、检测项目等），支持自定义扩展、分类分组管理等'
            },
            {
              title1: '流程',
              content1: '内置行业常用ECR-ECO变更方案，提供行业领先的用户可编程引擎，支持拖曳式自定义配置'
            },
            {
              title1: '报表',
              content1: '预置多场景自动图表（如对比图、统计图、走势图等）与分析表单，支持导出与打印'
            },
            {
              title1: '项目',
              content1: '项目计划+项目进度+项目交付+项目报表，帮助企业实现项目集管理，规范项目数据，缩短研发周期'
            }
          ]
        },
        {
          name: 'five',
          label: '数据建模',
          title: '5. 数据建模',
          description: '通过数据建模，支持客户个性化需求的高效灵活扩展，适应企业业务的发展衍变',
          effectDrawing: gn5,
          contentList: [
            {
              title1: '模型管理',
              content1: '支持数据、流程、字段级别的数据建模和精细化的权限控制'
            },
            {
              title1: '配置扩展',
              content1: '支持根据客户的个性化需求配置基础设置、对象分类、对象属性、工作流程、权限等'
            },
            {
              title1: '编码版本',
              content1: '支持适配企业体系化管理的各种编码、版本规则定义，支持内部文件与外来文件的差异化管理'
            },
            {
              title1: '用户管理',
              content1: '组织架构管理、用户信息管理、隶属关系管理、状态管理、行为日志、角色关联列表'
            },
            {
              title1: '角色权限',
              content1: '角色配置、用户关联、字段级数据权限、菜单权限、页签权限、按钮权限、读写权限'
            }
          ]
        }
      ],
      caseList: [
        {
          label: '通讯材料行业',
          link: 'https://www.purvar.com/case/c-plm-cailiao-tongxin.html',
          img: al1
        },
        {
          label: '电子材料行业',
          link: 'https://www.purvar.com/case/c-plm-cailiao-dianzi.html',
          img: al2
        },
        {
          label: '石油白油行业',
          link: 'https://www.purvar.com/case/c-plm-cailiao-shiyou.html',
          img: al3
        }
      ],
      caseList2: [
        {
          label: '某集团公司案例',
          link: 'https://www.purvar.com/case/c-pms-jituan.html',
          img: al2_1
        },
        {
          label: '医疗器械公司',
          link: 'https://www.purvar.com/case/c-pms-yiliao.html',
          img: al2_2
        },
        {
          label: '设备研发公司',
          link: 'https://www.purvar.com/case/c-pms-shebei.html',
          img: al2_3
        }
      ],
      schemeList: [
        {
          val: '01',
          label: '项目经理',
          title: '项目经理的主要烦恼',
          descriptions: [
            '项目准备时没有以往项目的经验可参考，无法利用已有沉淀信息有效提高项目准备的效率；',
            '获取任务执行情况完全依靠电话、邮件等沟通方式，费时费力；',
            '项目问题和风险没有经验库能够参考，完全依靠项目团队的能力；',
            '项目汇报占用时间和精力较多。'
          ],
          mainDesc: '基于这些烦恼，项目经理在PMS方面有以下期待。',
          mianFeatures: [
            { icon: xmjl1, label: '经验总结和沉淀' },
            { icon: xmjl2, label: '高效的沟通方式' },
            { icon: xmjl3, label: '可参考的经验库' },
            { icon: xmjl4, label: '高效的项目汇报' },
          ]
        },
        {
          val: '02',
          label: '管理高层',
          title: '管理高层的主要烦恼',
          descriptions: [
            '获取项目信息的途径主要是月会、书面汇报及与项目经理沟通，信息滞后且不全面，决策滞后且带有部分主观性；',
            '公司重点项目无法及时监控，决策往往滞后，造成项目投入人力和其他成本浪费。'
          ],
          mainDesc: '基于这些烦恼，管理高层在PMS方面有以下期待。',
          mianFeatures: [
            { icon: zywt1, label: '及时的项目信息' },
            { icon: zywt2, label: '客观的项目数据' },
            { icon: zywt3, label: '切实的项目监控' },
            { icon: zywt4, label: '高效的管理决策' },
          ]
        },
        {
          val: '03',
          label: 'PMO',
          title: 'PMO的主要烦恼',
          descriptions: [
            '制定的项目管理规范很难落地，往往是规范和实际业务两张皮；',
            '监控项目进度和项目质量很困难，都需要找项目经理了解；',
            '收集信息不全面，对项目绩效很难做出评价或者评价不够公正和客观。',
          ],
          mainDesc: '基于这些烦恼，PMO在PMS方面有以下期待。',
          mianFeatures: [
            { icon: zywt1, label: '项目规范的落地' },
            { icon: zywt3, label: '切实的项目监控' },
            { icon: zywt2, label: '客观的项目数据' },
            { icon: zywt5, label: '公正的项目评价' },
          ]
        },
        {
          val: '04',
          label: '项目团队成员',
          title: '项目团队成员',
          descriptions: [
            '个人参与多个项目，任务数量多且难以有效管理，管理不到位造成部分任务逾期完成；',
            '前置任务的完成时间和输出质量对自身任务影响很大；',
            '与团队成员沟通均通过邮件、电话等传统方式，查找历史信息耗时耗力。'
          ],
          mainDesc: '基于这些烦恼，项目团队成员在PMS方面有以下期待项目团队成员的主要诉求。',
          mianFeatures: [
            { icon: zywt1, label: '多项目有效管理' },
            { icon: zywt6, label: '前置任务的管理' },
            { icon: xmjl2, label: '高效的沟通方式' },
            { icon: zywt5, label: '作业风险的预警' },
          ]
        }
      ],
      listData: [
        {
          num: '01',
          title: '管理高层',
          contentList: [
            {
              content: '通过项目组合仪表盘、项目仪表盘、项目路线图等功能及时查看项目健康状况，通过内嵌数据钻取功能精准定位获取数据，基于全方位的项目数据进行高效决策。'
            }
          ]
        },
        {
          num: '02',
          title: '项目经理',
          contentList: [
            {
              content: '借助项目建模及丰富的计划（主计划、子计划、周计划）管理方式，单项目仪表盘、任务状态、项目问题及风险等信息提高项目经理进行项目准备与监控的效率。'
            }
          ]
        },
        {
          num: '03',
          title: 'PMO',
          contentList: [
            {
              content: '以对象和流程建模工具为依托，实现项目过程管理规则的落地，通过文档库及经验库实现项目管理经验的沉淀，将项目经验进行有效的传承和推广。'
            }
          ]
        },
        {
          num: '04',
          title: '项目团队成员',
          contentList: [
            {
              content: '通过待办任务分层管理模式，实现多任务有效管理。通过任务的精细化管理，多各项任务的作业时间和进度进行高效的整理，并与其他成员进行协作。'
            }
          ]
        }
      ]
    }
  },
  mounted() {
    baiduConsult();
  },
  methods: {
   
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/mixins.scss";

.project-management {
  ::v-deep .srm-header {
    padding-right: 8rem;
  }
  ::v-deep .srm-carousel-box {
    .carousel-item {
      .description {
        width: 96rem;
      }
    }
  }
  ::v-deep .point-of-pain {
    .point-of-pain-title {
      padding: 10rem 0 2.4rem !important;
    }
    .point-of-pain-description {
      padding-bottom: 6.2rem !important;
    }
    .list-item {
      padding: 5.6rem 5.2rem 0rem 4.8rem !important;
      height: 24.6rem !important;
      .cl-list {
        margin-top: 3rem !important;
      }
      .cl-l-i-content {
        padding-left: 0 !important;
        &::before {
          border: none !important;
        }
      }
    }
  }
  ::v-deep .scheme-container {
    .content-title {
      margin-bottom: 3.3rem !important;
    }
    .right-content {
      padding: 4.8rem 4.8rem 4rem !important;
      .content-context-w {
        height: 14.5rem;
        .content-context {
          line-height: 2.4rem !important;
          margin-bottom: 0 !important;
          &::before {
            content: '◇';
          }
        }
      }
      .content-bottom {
        padding-top: 0rem !important;
      }
    }
  }
  ::v-deep .productfeature .tab-container .el-tabs .el-tabs__header .el-tabs__nav .el-tabs__item {
    width: 28rem;
  }
  ::v-deep .productfeature {
    .content-left {
      padding: 0;
      left: 26rem;
      width: 54rem;
    }
    .content-right {
      width: 88.2rem;
      height: 51rem;
      top: 12.7rem;
      right: 17.1rem;
    }
  }

  @include mobile-page-overrides;
}
</style>
